import { AlarmStatusFilter } from 'sigma-mappings';

const installationStatusLookup = vm => ([
  {
    id: AlarmStatusFilter.NORMAL,
    name: vm.$t('alarms-and-warnings.installation.normal'),
  },
  {
    id: AlarmStatusFilter.DISABLED_INSTALLATION,
    name: vm.$t('alarms-and-warnings.installation.disabled'),
  },
  {
    id: AlarmStatusFilter.BLOCKED_INSTALLATION,
    name: vm.$t('alarms-and-warnings.installation.blocked'),
  },
]);

export default installationStatusLookup;
